"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.file)) {
        return '';
    }
    const { file, label } = element.value;
    const title = label || 'Download';
    const url = (0, md_utils_1.getFileUrl)(file, context);
    if (url) {
        return `[${title}](${url})\n\n`;
    }
    return `${title}\n\n`;
};
exports.toMarkdown = toMarkdown;
